/*
  Koral Boutique - ajustes de UX que no pueden hacerse solo con CSS.

  1) Contador de lista de deseos: mostraba un "0" permanente. Se marca como
     vacio para que el CSS lo oculte; reaparece solo con algo guardado.

  2) Sello de calidad bajo el titulo, en tarjetas y en la ficha. Es un sello
     de marca con datos ciertos, NO una calificacion: no lleva numero ni
     estrellas. No convertirlo en "4.9/5" ni en estrellas sin reseñas reales
     detras (publicidad engañosa). Para cambiar el texto, editar SELLO_*.
*/
(function () {
  if (window.__koralUx) return;
  window.__koralUx = true;

  var SELLO_TARJETA = 'Selección de la boutique';
  var SELLO_FICHA = 'Seda y algodón importado · Selección de la boutique';
  var ICONO = '<svg class="koral-sello__ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.4 6.9H22l-6 4.4 2.3 7L12 16l-6.3 4.3 2.3-7-6-4.4h7.6z"/></svg>';

  function crear(texto) {
    var d = document.createElement('div');
    d.className = 'koral-sello';
    d.innerHTML = ICONO + '<span>' + texto + '</span>';
    return d;
  }

  function revisar() {
    var b = document.querySelectorAll('.wishlist-count-bubble, .cart-count-bubble');
    Array.prototype.forEach.call(b, function (el) {
      var n = (el.textContent || '').replace(/\D/g, '');
      if (n === '' || n === '0') el.setAttribute('data-koral-vacio', '1');
      else el.removeAttribute('data-koral-vacio');
    });

    // Tarjetas: justo debajo del nombre.
    Array.prototype.forEach.call(document.querySelectorAll('.product-card-wrapper .card__information'), function (info) {
      if (info.querySelector('.koral-sello')) return;
      var h = info.querySelector('.card__heading');
      if (!h) return;
      h.parentNode.insertBefore(crear(SELLO_TARJETA), h.nextSibling);
    });


    // Distintivo "Nueva temporada" en las tarjetas del vestido mariposa.
    // Se decide por el handle para no pedir datos extra al servidor.
    Array.prototype.forEach.call(document.querySelectorAll('.product-card-wrapper'), function (w) {
      var a = w.querySelector('a[href*="/products/vestido-mariposa"]');
      var caja = w.querySelector('.card__inner') || w.querySelector('.card__media');
      if (!a || !caja || caja.querySelector('.koral-nuevo')) return;
      var n = document.createElement('span');
      n.className = 'koral-nuevo koral-nuevo--card';
      n.textContent = 'Nueva temporada';
      caja.appendChild(n);
    });

    // Ficha de producto: una sola vez por ficha, debajo del primer titulo.
    // El tema pinta dos .product__title en contenedores distintos; por eso se
    // controla a nivel de la columna de informacion y no del padre del titulo.
    Array.prototype.forEach.call(document.querySelectorAll('.product__info-container'), function (col) {
      if (col.querySelector('.koral-sello--ficha')) return;
      var t = col.querySelector('.product__title');
      if (!t) return;
      var s = crear(SELLO_FICHA);
      s.classList.add('koral-sello--ficha');
      t.parentNode.insertBefore(s, t.nextSibling);
    });
  }


  // 3) Barra fija de compra en la home, solo en celular. Aparece al pasar el
  //    hero y se esconde al llegar al pie para no tapar el newsletter.
  function barra() {
    if (location.pathname !== '/' || window.innerWidth >= 750 || document.getElementById('koral-barra')) return;
    var b = document.createElement('a');
    b.id = 'koral-barra';
    b.href = '/collections/vestido-mariposa';
    b.innerHTML = '<span class="koral-barra__txt"><strong>Vestido mariposa \u00b7 $1,199</strong><small>Nueva temporada \u00b7 Talla \u00fanica</small></span><span class="koral-barra__btn">Comprar</span>';
    document.body.appendChild(b);
    var pie = document.querySelector('[id*="newsletter_wBpfkb"], .footer');
    function upd() {
      var y = window.scrollY || 0;
      var fin = pie ? pie.getBoundingClientRect().top < window.innerHeight : false;
      if (y > 700 && !fin) b.classList.add('is-on'); else b.classList.remove('is-on');
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', barra); else barra();


  // 4) Cabecera glass. En la home se superpone al hero (transparente con vidrio
  //    esmerilado); al hacer scroll, y en el resto de paginas, el vidrio se
  //    oscurece un poco para que el texto blanco siempre se lea.
  function cabecera() {
    var sec = document.querySelector('.section-header');
    if (!sec || sec.dataset.koralGlass) return;
    sec.dataset.koralGlass = '1';
    document.documentElement.classList.add('koral-glass');
    if (location.pathname === '/') document.documentElement.classList.add('koral-home');
    function medir() {
      var h = sec.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--koral-hh', h + 'px');
    }
    function scroll() {
      if ((window.scrollY || 0) > 30) document.documentElement.classList.add('koral-scrolled');
      else document.documentElement.classList.remove('koral-scrolled');
    }
    medir(); scroll();
    window.addEventListener('resize', medir, { passive: true });
    window.addEventListener('load', medir);
    window.addEventListener('scroll', scroll, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cabecera); else cabecera();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revisar);
  else revisar();
  window.addEventListener('load', revisar);
  setTimeout(revisar, 1000);
  setTimeout(revisar, 2500);
  document.addEventListener('shopify:section:load', revisar);
  if ('MutationObserver' in window) {
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      setTimeout(function () { pend = false; revisar(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
